<template>
      <div class="user-container d-flex justify-content order-0">
        <div class="user-container__logo">
          <img src="/assets/images/Group-user-pic.png" alt="user image">
        </div>
        <div class="user-container__info d-flex flex-column justify-content-between">
          <h5 class="user-container__info__name font-weight-600">
            <template v-if="store.state.customer.company_name">
              {{ store.state.customer.company_name }}
            </template>
            <template v-else>
              {{ store.state.customer.first_name ?? '' }} {{ store.state.customer.last_name ?? '' }}
            </template>
          </h5>
          <div class=" user-container__info__email font-big">{{ store.state.customer.email }}</div>
        </div>
      </div>

      <div class="hr-line m-2 mb-3 order-1"></div>


</template>

<script lang="ts">
import {defineComponent} from "vue";
import {useStore} from "vuex";


export default defineComponent({
  name: 'UserYesLoggedWrapperComponent',
  components: {},
  props: {},
  data() {
    return {}
  },
  setup() {
    const store = useStore();

    return {
      store,
    };
  },
  methods: {}
})
</script>
